export default "__VITE_ASSET__DtR26tp$__"